import {getDrugItemFormDefaultValues, initializeDoseLimits} from '@/modules/drug-catalog/functions'
import {ActiveSubstanceFormSchema} from '@/modules/drug-catalog/substances/schemas'
import {PreparationType} from '@cypro/engine/database/schema'
import {DrugCatalogItem, Settings} from '@cypro/engine/schema'
import {SelectItem} from '@cypro/ui/components/form/select'
import {elementToArray} from '@cypro/ui/utils'

export function getSubstanceFormDefaultValues(
  substance: DrugCatalogItem | undefined,
  settings?: Settings
): ActiveSubstanceFormSchema {
  let preparationType: PreparationType | null = null
  // allow only volumetric if the org has no scales and the user is adding a substance
  if (!substance && settings?.useScales === false) {
    preparationType = PreparationType.enum.VOLUMETRIC
  } else if (substance?.activeSubstanceDetails?.preparationType) {
    preparationType = substance?.activeSubstanceDetails?.preparationType
  }

  return {
    ...getDrugItemFormDefaultValues(substance),
    doseCalculationMethod: elementToArray(substance?.activeSubstanceDetails?.doseCalcMode),
    doseUnitId: elementToArray(substance?.activeSubstanceDetails?.doseUnitId),
    doseLimits: initializeDoseLimits(substance?.activeSubstanceDetails?.doseLimits),
    roundingMode: elementToArray(substance?.activeSubstanceDetails?.roundingMode),
    // 0 decimals is a valid precision; only an unset value falls back to the default
    precision: substance?.activeSubstanceDetails?.dosePrecision ?? 2,
    minIntervalValue: substance?.activeSubstanceDetails?.minIntervalValue || 0,
    minIntervalUnit: elementToArray(substance?.activeSubstanceDetails?.minIntervalDurationUnit),
    overdosePreventionLevel: elementToArray(substance?.activeSubstanceDetails?.overdosePreventionLevel),
    hazardClassId: substance?.activeSubstanceDetails?.hazardClasses?.map(j => j.hazardClassId) || [],
    hasSaltContent: Boolean(substance?.activeSubstanceDetails?.hasSaltContent),
    molarMassFreeBase: substance?.activeSubstanceDetails?.molarMassFreeBase || 0,
    molarMassSaltBase: substance?.activeSubstanceDetails?.molarMassSaltBase || 0,
    saltFactor: substance?.activeSubstanceDetails?.saltFactor || 0,
    additionalApprovalRequired: Boolean(substance?.activeSubstanceDetails?.additionalApprovalRequired),
    cytotoxic: substance?.activeSubstanceDetails?.cytotoxic ?? true,
    routeWarning: Boolean(substance?.activeSubstanceDetails?.routeWarning),
    productionNotes: substance?.activeSubstanceDetails?.productionNotes || '',
    externalInformationLink: substance?.activeSubstanceDetails?.externalInformationLink || '',
    preparationType: elementToArray(preparationType),
    machineId: '',
  }
}

export function mapSubstancesToSelectItems(activeSubstanceDrugs: DrugCatalogItem[]): SelectItem[] {
  return activeSubstanceDrugs.map(s => ({value: s.id, label: s.name}))
}

export function isSubstanceDeletable(_substance: DrugCatalogItem) {
  // TODO: implement active substances v2
  // return !substance.tradeNames?.length
  return true
}
